import { render, staticRenderFns } from "./Step-6.vue?vue&type=template&id=34a00f0f&scoped=true"
import script from "./Step-6.vue?vue&type=script&lang=js"
export * from "./Step-6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a00f0f",
  null
  
)

export default component.exports